export const specials = [
  {
    id: "silent-current",
    title: "静水深流：华语悬疑的「慢」与「狠」",
    subtitle: "专题策划 · 第 12 期",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20moody%20image%20of%20a%20slow%20dark%20river%20at%20dusk%20with%20fog%20drifting%20over%20the%20water%20and%20a%20single%20lit%20window%20on%20the%20far%20bank%20deep%20navy%20blue%20tones%20with%20amber%20highlights%20atmospheric%20editorial%20photography%20no%20text%20high%20detail&width=1200&height=675&seq=rs-special-silent&orientation=landscape",
    intro:
      "过去三年，华语悬疑不再靠密集反转取胜，而是把镜头对准了更慢的东西：一条河、一份档案、一段被反复回忆的夜晚。我们挑选四部作品，聊聊这种「慢」为什么反而更狠。",
    groups: [
      {
        name: "视点：谁在讲故事",
        entries: [
          {
            filmId: "dark-river",
            title: "河流不会作证，但它记得",
            author: "沈青",
            excerpt: "《暗河》把调查的重心从凶手转移到整座城，视点的选择决定了它不只是一部刑侦剧。",
          },
          {
            filmId: "silent-testimony",
            title: "当证人无法开口",
            author: "阿Ken",
            excerpt: "《无声证词》让庭审戏回到语言本身，沉默成为一种证词，也是一种控诉。",
          },
        ],
      },
      {
        name: "方法：如何对待真相",
        entries: [
          {
            filmId: "long-night",
            title: "破案只是外壳，拆迁才是内核",
            author: "林未",
            excerpt: "《长夜将尽》用一条街的消失，换来了一个更残酷的问题：谁有权决定记忆的去留。",
          },
          {
            filmId: "last-metro",
            title: "密闭空间里的自我审判",
            author: "温晴",
            excerpt: "《末班地铁》以类型片的方式讨论悔恨，设定亮眼，结尾的解释却略显仓促。",
          },
        ],
      },
    ],
    reason:
      "这四部作品的共同点在于：都不急着给观众答案。它们把时间花在环境、声音与沉默上，让悬疑从「猜凶手」变成「看清一个地方」。如果你已经厌倦了靠剪辑制造的反转，这一期会给你另一种节奏。",
    related: ["ordinary-lives", "memory-machine"],
  },
  {
    id: "ordinary-lives",
    title: "烟火人间：当日常成为最好的剧本",
    subtitle: "专题策划 · 第 11 期",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20cinematic%20still%20of%20a%20small%20family%20kitchen%20table%20with%20steaming%20homemade%20dishes%20and%20afternoon%20sunlight%20through%20a%20window%20deep%20navy%20shadows%20and%20soft%20amber%20tones%20cozy%20documentary%20style%20no%20text%20high%20detail&width=1200&height=675&seq=rs-special-ordinary&orientation=landscape",
    intro:
      "没有凶案，没有末日，只有一日三餐和一条住了三十年的街。这些剧集证明，最难的戏往往发生在饭桌上。",
    groups: [
      {
        name: "在一顿饭里讲完一生",
        entries: [
          {
            filmId: "mountain-table",
            title: "先让你看清一锅汤怎么熬",
            author: "林未",
            excerpt: "《山海食单》不急着煽情，食物是引子，真正被端上桌的是留下与离开。",
          },
          {
            filmId: "alley-diner",
            title: "天亮了，各自散去",
            author: "林馥",
            excerpt: "《小巷食堂》从不劝人想开，只是把饭端上来，让人先吃饱再难过。",
          },
        ],
      },
      {
        name: "一条街的时间",
        entries: [
          {
            filmId: "old-street",
            title: "缝纫机的声音就是时间",
            author: "顾南",
            excerpt: "《长街旧梦》不美化过去，也不审判过去，只是认真地让那条街再亮一次灯。",
          },
          {
            filmId: "glasshouse",
            title: "不结果的花也是一种答案",
            author: "唐寻",
            excerpt: "《玻璃温室》拒绝给出和解的仪式感，只让三个人安静地吃完一顿饭。",
          },
          {
            filmId: "summer-end",
            title: "冰店里融化得太快的刨冰",
            author: "苏念",
            excerpt: "《我们在夏天结尾》没有暴雨中的告白，这才是我们真正经历的十八岁。",
          },
        ],
      },
    ],
    reason:
      "当类型片越来越依赖强刺激，这些作品选择把镜头放低，放到灶台、缝纫机与海堤的高度。它们不提供答案，只提供陪伴，而陪伴本身就足够稀缺。",
    related: ["silent-current", "memory-machine"],
  },
  {
    id: "memory-machine",
    title: "被记忆修改的人：科幻影像中的身份焦虑",
    subtitle: "专题策划 · 第 10 期",
    cover:
      "https://readdy.ai/api/search-image?query=futuristic%20dark%20control%20room%20with%20a%20giant%20glowing%20circular%20interface%20and%20a%20lone%20silhouette%20seen%20from%20behind%20cold%20reflections%20on%20glass%20deep%20navy%20blue%20tones%20with%20amber%20glow%20editorial%20sci%20fi%20photography%20no%20text%20high%20detail&width=1200&height=675&seq=rs-special-memory&orientation=landscape",
    intro:
      "如果记忆可以上传、删除、延迟送达，那么「我是谁」还成立吗？四部科幻作品给出了完全不同的回答。",
    groups: [
      {
        name: "备份与删除",
        entries: [
          {
            filmId: "zero-plan",
            title: "真正的恐怖是无法证明自己存在",
            author: "韩知远",
            excerpt: "《归零计划》把记忆伦理拍成了悬疑，冷色调里藏着极热的情感。",
          },
          {
            filmId: "deep-sea-echo",
            title: "沉默比深海更冷",
            author: "沈青",
            excerpt: "《深海回声》用光线与水压讲述家庭秘密，记忆在这里是打捞物。",
          },
        ],
      },
      {
        name: "距离与延迟",
        entries: [
          {
            filmId: "star-postman",
            title: "一封信要走三年",
            author: "周衍",
            excerpt: "《星际邮差》没有拯救宇宙，只有一封信到底要不要拆开。",
          },
          {
            filmId: "wasteland-courier",
            title: "末日里最稀缺的是地址",
            author: "Nora",
            excerpt: "《荒原信使》把宏大世界观压缩成两个人和一条路线，废墟因此有了体温。",
          },
        ],
      },
    ],
    reason:
      "这四部作品共同关心的不是技术，而是技术之后的人：当记忆可以被编辑，情感是否还算证据？当信息延迟三年，道歉还有没有意义？这些问题没有标准答案，但值得反复追问。",
    related: ["silent-current", "ordinary-lives"],
  },
];